import firebase from 'firebase/app';
import { userStore } from '../store/userStore';

export default {
	upload: async function(entity, id, file, progressCallback) {
		return new Promise(async (resolve, reject) => {
			const path = `${userStore.getters.getCompany}/${entity}`;
			const storage = firebase.storage().ref(path);
			const extension = file.type.split('/')[1];
			const name = `${id}.${extension}`;

			try {
				await this.deleteFile(entity, name);

				const uploadTask = storage.child(name).put(file);

				uploadTask.on(
					firebase.storage.TaskEvent.STATE_CHANGED,
					function(snapshot) {
						const progress = parseInt(snapshot.bytesTransferred / snapshot.totalBytes * 100);
						if (progressCallback) {
							progressCallback(progress);
						}
					},
					function(error) {
						console.error('Upload >> ', error);
					},
					async function() {
						const uri = await uploadTask.snapshot.ref.getDownloadURL();
						resolve({
							url: uri,
							fileNameRef: name
						});
					}
				);
			} catch (error) {
				reject(error);
			}
		});
	},

	async deleteFile(entity, fileName) {
		const storage = firebase.storage().ref(entity);
		try {
			await storage.child(fileName).delete();
		} catch (e) {}
		return true;
	}
};
